import { SystemConfig } from "@/configs";
import PublisherConfig from "@/configs/publisher.json";

export type SubscribePlan = "free" | "monthly" | "annual";

export interface PaidPlanPrice {
  price: number;
  currency: string;
  stripePriceId: string;
}

export interface PaidSubscriptionsConfig {
  status: string;
  stripeProductId?: string;
  activatedAt?: number;
  monthly?: PaidPlanPrice;
  annual?: PaidPlanPrice;
}

export function getPaidSubscriptions(): PaidSubscriptionsConfig | null {
  const paid = (PublisherConfig as { paidSubscriptions?: PaidSubscriptionsConfig }).paidSubscriptions;
  if (!paid || typeof paid !== "object") return null;
  return paid;
}

// Global flag (system.json) AND this publisher has active paid plans.
export function isPaidEnabled(): boolean {
  if (!SystemConfig.paymentEnabled) return false;
  const paid = getPaidSubscriptions();
  return (
    paid?.status === "active" &&
    typeof paid.monthly?.stripePriceId === "string" &&
    paid.monthly.stripePriceId.length > 0 &&
    typeof paid.annual?.stripePriceId === "string" &&
    paid.annual.stripePriceId.length > 0 &&
    typeof paid.monthly.price === "number" &&
    typeof paid.annual.price === "number"
  );
}

export function formatUsdFromCents(cents: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format((cents || 0) / 100);
}
